import { Button, Heading, InputField } from "@/common/components";
import { useContext, useCallback } from "@/common/hooks";
import { ProductContext } from "../ViewProductDetails";

const ProductPageTwo = ({ next }) => {
  const { labels, onChange, errorProps, productData, back, addProduct } =
    useContext(ProductContext);

  const checkDisabled = useCallback(() => {
    let disable = false;

    if (
      !addProduct &&
      productData?.setupComplete == "true" &&
      productData?.activeDt != ""
    ) {
      let requiredFields = [
        "PRODUCT_MIN_ENTRY_AGE",
        "PRODUCT_MAX_ENTRY_AGE",
        "PRODUCT_ELIGIBLE_WITHDRAWAL_AGE",
        "PRODUCT_MANDATORY_WITHDRAWAL_AGE",
        "PRODUCT_MIN_INITIAL_PURCHASE_AMOUNT",
        "PRODUCT_MIN_ADDITIONAL_PURCHASE_AMOUNT",
        "PRODUCT_MAX_TOTAL_PURCHASE_AMOUNT",
        "PRODUCT_GUARANTEED_BENEFITS_AGE",
      ];

      if (productData?.productType === "W") {
        requiredFields = [
          ...requiredFields,
          "PRODUCT_MIN_PORTFOLIO_BALANCE_PAYOUT_TRIGGER_AMOUNT",
          "PRODUCT_GUARANTEED_BENEFITS_AGE_2",
          "PRODUCT_GUARANTEED_BENEFITS_AGE_3",
          "PRODUCT_MIN_BENEFIT_BASE_AMOUNT",
          "PRODUCT_MAX_BENEFIT_BASE_AMOUNT",
          "PRODUCT_ELIGIBLE_WITHDRAWAL_AGE_MONTH",
        ];
      }

      requiredFields.forEach((e) => {
        if (!productData[e]) {
          disable = true;
        }
      });
    }

    return disable;
  }, [productData]);

  return (
    <section className="container-medium py-5">
      <div className="mb-5">
        <Heading
          text={labels?.product?.ownerQualifications}
          wrapperClassNames="h4 border-bottom-1 pb-2 mb-3"
          title={false}
        />

        <div className="fw-bold mb-2">{labels?.product?.entryAge}</div>
        <InputField
          id="minimum"
          label={labels?.product?.minimum}
          type="number"
          max="999"
          wrapperClassName="col-md-2"
          change={(e) => onChange(e, "PRODUCT_MIN_ENTRY_AGE")}
          {...errorProps("PRODUCT_MIN_ENTRY_AGE")}
        />

        <InputField
          id="maximum"
          label={labels?.product?.maximum}
          type="number"
          max="999"
          wrapperClassName="col-md-2"
          change={(e) => onChange(e, "PRODUCT_MAX_ENTRY_AGE")}
          {...errorProps("PRODUCT_MAX_ENTRY_AGE")}
        />

        <div className="fw-bold mb-2 mt-4">
          {labels?.product?.withdrawalAge}
        </div>
        <InputField
          id="eligibility"
          label={
            productData?.productType === "W"
              ? labels?.product?.eligibleYears
              : labels?.product?.eligibility
          }
          type="number"
          max="999"
          wrapperClassName="col-md-2"
          change={(e) => onChange(e, "PRODUCT_ELIGIBLE_WITHDRAWAL_AGE")}
          {...errorProps("PRODUCT_ELIGIBLE_WITHDRAWAL_AGE")}
        />

        {productData?.productType === "W" && (
          <InputField
            id="eligibility-months"
            label={labels?.product?.months}
            type="number"
            max="11"
            wrapperClassName="col-md-2"
            change={(e) => onChange(e, "PRODUCT_ELIGIBLE_WITHDRAWAL_AGE_MONTH")}
            {...errorProps("PRODUCT_ELIGIBLE_WITHDRAWAL_AGE_MONTH")}
          />
        )}

        <InputField
          id="mandatory"
          label={labels?.product?.mandatory}
          type="number"
          max="999"
          wrapperClassName="col-md-2"
          change={(e) => onChange(e, "PRODUCT_MANDATORY_WITHDRAWAL_AGE")}
          {...errorProps("PRODUCT_MANDATORY_WITHDRAWAL_AGE")}
        />
      </div>

      {productData?.productType === "W" && (
        <div className="mb-5">
          <Heading
            text={labels?.product?.incomeBase}
            wrapperClassNames="h4 border-bottom-1 pb-2 mb-3"
            title={false}
          />
          <InputField
            id="minBenefitAmount"
            label={labels?.product?.minBenefitAmount}
            type="number"
            max="9999999999999999"
            showDollarSign={true}
            decimal={true}
            change={(e) => onChange(e, "PRODUCT_MIN_BENEFIT_BASE_AMOUNT")}
            {...errorProps("PRODUCT_MIN_BENEFIT_BASE_AMOUNT")}
          />
          <InputField
            id="maxBenefitAmount"
            label={labels?.product?.maxBenefitAmount}
            type="number"
            max="9999999999999999"
            showDollarSign={true}
            decimal={true}
            change={(e) => onChange(e, "PRODUCT_MAX_BENEFIT_BASE_AMOUNT")}
            {...errorProps("PRODUCT_MAX_BENEFIT_BASE_AMOUNT")}
          />
        </div>
      )}

      <div className="mb-5">
        <Heading
          text="Investment Restrictions"
          wrapperClassNames="h4 border-bottom-1 pb-2 mb-3"
          title={false}
        />
        <InputField
          id="minPurchaseAmount"
          label={labels?.product?.minPurchaseAmount}
          type="number"
          max="9999999999999999"
          showDollarSign={true}
          decimal={true}
          change={(e) => onChange(e, "PRODUCT_MIN_INITIAL_PURCHASE_AMOUNT")}
          {...errorProps("PRODUCT_MIN_INITIAL_PURCHASE_AMOUNT")}
        />
        <InputField
          id="minAdditionalPurchaseAmount"
          label={labels?.product?.minAdditionalPurchaseAmount}
          type="number"
          max="9999999999999999"
          showDollarSign={true}
          decimal={true}
          change={(e) => onChange(e, "PRODUCT_MIN_ADDITIONAL_PURCHASE_AMOUNT")}
          {...errorProps("PRODUCT_MIN_ADDITIONAL_PURCHASE_AMOUNT")}
        />
        <InputField
          id="maxTotalPurchaseAmount"
          label={labels?.product?.maxTotalPurchaseAmount}
          type="number"
          max="9999999999999999"
          showDollarSign={true}
          decimal={true}
          change={(e) => onChange(e, "PRODUCT_MAX_TOTAL_PURCHASE_AMOUNT")}
          {...errorProps("PRODUCT_MAX_TOTAL_PURCHASE_AMOUNT")}
        />
        {productData?.productType === "W" && (
          <InputField
            id="minPortfolioAmount"
            label={labels?.product?.minPortfolioAmount}
            type="number"
            max="9999999999999999"
            showDollarSign={true}
            decimal={true}
            change={(e) =>
              onChange(e, "PRODUCT_MIN_PORTFOLIO_BALANCE_PAYOUT_TRIGGER_AMOUNT")
            }
            {...errorProps(
              "PRODUCT_MIN_PORTFOLIO_BALANCE_PAYOUT_TRIGGER_AMOUNT"
            )}
          />
        )}
      </div>

      <div className="mb-5">
        <Heading
          text={labels?.product?.ownerEnquiry}
          wrapperClassNames="h4 border-bottom-1 pb-2 mb-3"
          title={false}
        />
        <div className="fw-bold mb-2">{labels?.product?.guaranteedAges}</div>
        <div className="d-flex">
          <InputField
            id="guaranteedAges1"
            ariaLabel="guaranteedAges1"
            type="number"
            label=""
            max="999"
            wrapperClassName="col-2 me-2"
            change={(e) => onChange(e, "PRODUCT_GUARANTEED_BENEFITS_AGE")}
            {...errorProps("PRODUCT_GUARANTEED_BENEFITS_AGE")}
          />
          {productData?.productType === "W" && (
            <>
              <InputField
                id="guaranteedAges2"
                ariaLabel="guaranteedAges2"
                type="number"
                max="999"
                wrapperClassName="col-2 me-2"
                change={(e) => onChange(e, "PRODUCT_GUARANTEED_BENEFITS_AGE_2")}
                {...errorProps("PRODUCT_GUARANTEED_BENEFITS_AGE_2")}
              />
              <InputField
                id="guaranteedAge3"
                ariaLabel="guaranteedAges3"
                type="number"
                max="999"
                wrapperClassName="col-2"
                change={(e) => onChange(e, "PRODUCT_GUARANTEED_BENEFITS_AGE_3")}
                {...errorProps("PRODUCT_GUARANTEED_BENEFITS_AGE_3")}
              />
            </>
          )}
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <Button
          id="back"
          type="secondary"
          text={labels?.product?.back}
          wrapperClassName="col-md-4 col-6 me-md-2 px-2"
          click={back}
          
        />
        <Button
          id="next"
          text={labels?.product?.next}
          wrapperClassName="col-md-4 col-6"
          click={next}
          disabled={checkDisabled()}
        />
      </div>
    </section>
  );
};

export default ProductPageTwo;
